import { createApp } from 'vue';
import { Dialog } from '@printos/agnostic-dialog';

export default class PrintOSDialog extends Dialog {
  constructor(i18n) {
    super();
    this._i18n = i18n;
  }

  show(vm, options) {
    // Destructure options
    // (in the process omit what we don't want to send to PrintosDialog)
    let {titleKey, content, ...dialogOpts} = options;

    const tempDiv = document.createElement('div');
    this.instance = createApp(content, options.propsData);
    this.instance.use(this._i18n);
    this.instance.mount(tempDiv);
    dialogOpts.content = tempDiv;

    if (titleKey) {
      dialogOpts.title = vm.$t(titleKey);
    }

    return super.show(dialogOpts);
  }

  hide(response) {
    return super.hide(response).then(val => {
      // this._vueDialog.$destroy();
      this.instance.unmount();
      return val;
    });
  }

  cancel(response) {
    return super.cancel(response).then(val => {
      // this._vueDialog.$destroy();
      this.instance.unmount();
      return val;
    });
  }
}

